import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
export function HeroSection() {
  const checkoutUrl = 'https://fonocheck.librosdigitales.pro/cart/44768212975752:1';
  return <section className="relative bg-[#EDF2F7] min-h-[calc(100dvh-2.5rem)] flex items-center px-4 sm:px-6 lg:px-8 py-2 md:py-16 overflow-hidden" data-id="element-19">
      <div className="max-w-4xl mx-auto text-center w-full" data-id="element-20">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="z-10" data-id="element-21">
          <div className="inline-block px-3 py-1 bg-blue-100 text-blue-900 font-semibold text-[9px] md:text-sm rounded-full mb-1.5 md:mb-6" data-id="element-22">
            Para fonoaudiólogas que trabajan con niños todas las semanas y
            necesitan estructura real.
          </div>

          <h1 className="text-xl sm:text-3xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-1 md:mb-4" data-id="element-23">
            6 MESES DE INTERVENCIÓN{' '}
            <span className="text-[#1B3A5C]" data-id="element-24">FONOAUDIOLÓGICA</span>
          </h1>

          <p className="text-[11px] sm:text-sm md:text-xl text-gray-600 mb-1 md:mb-6 font-medium leading-snug max-w-2xl mx-auto" data-id="element-25">
            Un sistema estructurado con 24 sesiones listas para usar, para dejar
            de improvisar sesiones y trabajar con seguridad clínica real.
          </p>

          <p className="text-sm md:text-xl font-bold text-[#1B3A5C] mb-4 md:mb-8" data-id="element-26">
            Para fonoaudiólogas que atienden todos los días y necesitan material
          </p>
        </motion.div>

        {/* Product Mockup - Below subtitle */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative flex justify-center items-center mb-1.5 md:mb-10 cursor-pointer" onClick={() => document.getElementById('compra')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-27">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[120%] bg-blue-100/50 rounded-full blur-3xl -z-10" data-id="element-28" />

          <img src="https://cdn.magicpatterns.com/uploads/3ab4r1BL9wBE5qcrJzpw1s/heylloyd-image-1773418231658-removebg-preview.png" alt="Mega Pack de Intervención Fonoaudiológica Infantil" className="w-full max-w-[207px] sm:max-w-[320px] md:max-w-xl lg:max-w-2xl h-auto drop-shadow-2xl hover:scale-105 transition-transform duration-500" data-id="element-29" />
        </motion.div>

        {/* Title + CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-30">
          <h2 className="text-sm sm:text-xl md:text-3xl font-bold text-[#1B3A5C] mb-1.5 md:mb-6" data-id="element-31">
            MEGA PACK DE INTERVENCIÓN FONOAUDIOLÓGICA INFANTIL
          </h2>

          <motion.button onClick={() => document.getElementById('compra')?.scrollIntoView({
          behavior: 'smooth'
        })} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} animate={{
          boxShadow: ['0 0 0 0 rgba(34, 197, 94, 0.7)', '0 0 0 10px rgba(34, 197, 94, 0)']
        }} transition={{
          boxShadow: {
            repeat: Infinity,
            duration: 1.5
          }
        }} className="bg-[#22C55E] text-white px-5 py-2.5 md:px-8 md:py-4 rounded-lg font-bold text-[11px] md:text-lg inline-flex items-center gap-2 shadow-lg hover:bg-[#16A34A] transition-colors cursor-pointer" data-id="element-32">
            Quiero trabajar con este sistema profesional
            <ArrowRightIcon className="w-3.5 h-3.5 md:w-5 md:h-5" data-id="element-33" />
          </motion.button>

          {/* Micro bullets */}
          <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 mt-2 md:mt-4" data-id="element-34">
            <span className="flex items-center gap-1 text-[10px] md:text-sm text-gray-500" data-id="element-35">
              <CheckIcon className="w-3 h-3 md:w-4 md:h-4 text-[#1B3A5C]" data-id="element-36" />
              Acceso inmediato
            </span>
            <span className="flex items-center gap-1 text-[10px] md:text-sm text-gray-500" data-id="element-37">
              <CheckIcon className="w-3 h-3 md:w-4 md:h-4 text-[#1B3A5C]" data-id="element-38" />
              Material descargable en PDF
            </span>
            <span className="flex items-center gap-1 text-[10px] md:text-sm text-gray-500" data-id="element-39">
              <CheckIcon className="w-3 h-3 md:w-4 md:h-4 text-[#1B3A5C]" data-id="element-40" />
              Uso profesional en consultorio
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}